/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-22",
    versionChannel: "nightly",
    buildDate: "2023-10-22T00:21:00.197Z",
    commitHash: "5f217a6b9a5c593c42de5c6f3b67f4ef290a7f84",
};
